import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  form: { username: "", email: "", password: "" },
  otpSent: false,
  userId: "",
  otp: "",
  msg: "",
  success: false,
  user: null, // Add user info here
};

const signupSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {
    setForm(state, action) {
      state.form = { ...state.form, ...action.payload };
    },
    setOtpSent(state, action) {
      state.otpSent = action.payload;
    },
    setUserId(state, action) {
      state.userId = action.payload;
    },
    setOtp(state, action) {
      state.otp = action.payload;
    },
    setMsg(state, action) {
      state.msg = action.payload;
    },
    setSuccess(state, action) {
      state.success = action.payload;
    },
    resetSignup(state) {
      Object.assign(state, initialState);
    },
    setUser(state, action) {
      state.user = action.payload;
    },
  },
});

export const {
  setForm,
  setOtpSent,
  setUserId,
  setOtp,
  setMsg,
  setSuccess,
  resetSignup,
  setUser, // export setUser
} = signupSlice.actions;

export default signupSlice.reducer;
